import { forwardRef, createElement } from 'react';
export { AlertCircle, Archive, Bell, Bot, Briefcase, Building2, Calendar, Check, ChevronDown, ChevronRight, FolderKanban, Inbox, KanbanSquare, ListChecks, Loader2, Mail, Menu, MoreHorizontal, Plus, Search, Send, Settings, Sparkles, Star, Tag, Users, X } from 'lucide-react';

// src/icons.ts
var ICON_STROKE = 1.75;
var Icon = forwardRef(function Icon2({ icon, size = 16, ...rest }, ref) {
  return createElement(icon, { ref, size, strokeWidth: ICON_STROKE, ...rest });
});

export { ICON_STROKE, Icon };
//# sourceMappingURL=chunk-ETUJHD53.js.map
//# sourceMappingURL=chunk-ETUJHD53.js.map